




























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { AdminInvoiceRoute } from '@/modules/invoice/routes/admin-invoice.route'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: { BaseButton }
})
export default class AdminDownloadInvoiceButton extends Vue {
  constructor(
    private readonly route: AdminInvoiceRoute
  ) {
    super()
  }

  @Prop({ required: true }) invoiceId!: number
  @Prop({ default: '' }) label!: string

  private get getDownloadLink() {
    return this.route.download(this.invoiceId)
  }
}
